//import moment from '@/moment-gp'
import moment from '@/moment-gp'

export default {
  /* Set high resolution timer */
  SET_SYSTEM_TIME_SECOND(state) {
    state.time_updated_every_sec = moment.currentTime().unix();
  },

  /* Set low resolution timer */
  SET_SYSTEM_TIME_MINUTE(state) {
    state.now_updated_every_min = moment.currentTime().unix();
  },

  SET_ACTIVE_SESSIONS_INDEX(state, newIndex) {
    state.activeSessionIndex = newIndex
  },

  SET_ACTIVE_SESSION(state, session) {
    state.activeSession = session
  },
  SET_NEXT_SESSION(state, session) {
    state.nextSession = session
  },
  SET_ACTIVE_SESSION_TIME_UNTIL_END(state, time) {
    state.activeSessionTimeUntilEnd = time
  },

  SET_ACTIVE_SESSION_TIME_UNTIL_START(state, time) {
    state.nextSessionTimeUntilStart = time
  },

  SET_TIMER_STATUS(state, newTimerStatus) {
    state.timer_status = newTimerStatus
  },

  RESET(state) {
    state.time_updated_every_sec = null
    state.now_updated_every_min = null
    state.activeSessionIndex = null
    state.timer_status = null;
  },

};
